import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useRef, useState } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicPayOnWodzone = () => {
  const { windowWidth, setOngletPaiementActif } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();

  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Payer une inscription', link: '/topics/paiement/payer-inscription'},
    { label: topic.title, link: topic.link},
  ]

// <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Il est essentiel d'effectuer vos paiements <strong>exclusivement via Wodzone.</strong> En choisissant de payer en dehors 
              de notre plateforme, vous renoncez à toutes les garanties de sécurité, de suivi des transactions 
              et d'assistance en cas de problème. Pour votre tranquillité d'esprit, veillez à toujours utiliser 
              notre système de paiement sécurisé.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Si vous êtes invité à payer par un moyen autre que le paiement en ligne sécurisé sur Wodzone, 
                il s'agit probablement d'une fraude. Assurez-vous de toujours finaliser vos transactions directement 
                sur notre plateforme pour éviter tout risque. Pour obtenir de l'aide,
                <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>contactez-nous immédiatement.</a> 
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Nous faisons de notre mieux pour vous protéger sur la plateforme Wodzone. 
                Nous bloquons les annonces potentiellement dangereuse qui contiennent des mots ou des numéros ressemblant à 
                des coordonnées ou des références à d'autres sites, notamment des liens externes. 
              </p>
              <p className="help-text">
                <a target='_blank' className="link ml-0" href={`/topics/about/62`}>En savoir plus sur notre Politique de confidentialité</a>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicPayOnWodzone